import { Box, Text } from '@mantine/core';
import { IconPropsType } from 'icons/types';
import {
  cloneElement,
  isValidElement,
  ReactElement,
  useMemo,
  type ReactNode,
} from 'react';

type Props = {
  icon: ReactNode;
  title: string;
  description: string | ReactNode;
};

export const Header = ({ icon, title, description }: Props) => {
  const decoratedIcon = useMemo(
    () =>
      isValidElement(icon)
        ? cloneElement(icon as ReactElement<IconPropsType>, { color: 'blue' })
        : null,
    [icon],
  );

  return (
    <Box
      sx={theme => ({
        display: 'flex',
        alignItems: 'center',
        gap: theme.other.spacing(1),
      })}
    >
      <Box
        sx={theme => ({
          background: theme.colors.blue[1],
          borderRadius: '50%',
          padding: theme.other.spacing(0.75),
          display: 'flex',
        })}
      >
        {decoratedIcon}
      </Box>
      <Box>
        <Text
          size="xl"
          fw={700}
          sx={theme => ({ marginBottom: theme.other.spacing(0.5) })}
        >
          {title}
        </Text>
        <Text size="md">{description}</Text>
      </Box>
    </Box>
  );
};
